import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { messages } from '../messages';

import style from '../address-validation.module.css';

const Revalidate = ({ onClick }) => (
  <div className={style['revalidate-address']}>
    <Button onClick={onClick} theme='link'>
      <FormattedMessage {...messages.validateAddress} />
    </Button>
  </div>
);

Revalidate.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export { Revalidate };
